<template>
	<span>
		<div class="row row-wrap">
      <!-- rem ellipsis -->
      <a :id="item.sid" class="col-xs-12 aItem row sideless" style="margin: 0px;" @click.prevent="item_clicked()">


      <div class="icon-text-container" 
      :class="{'active-tree-item': (item.sid == $root.active_tree_item.id && ($route.query.p == item.idp || $route.query.p == null ) )}">
        <span style="padding: 0px;">
          <!-- width: 5%; -->
          <div class="sideless side-branch"
          v-if="!isFirstSon"
          :class="{'last': ind == $parent.children.length - 1}"> <!-- || (item.opened && children.length > 0) -->
            <div class="branch top"></div>
            <div class="branch bot"></div>
          </div>
          <i v-if="!configs.showValidity || true" :class="$root.prod_icons[item.typ] ? $root.prod_icons[item.typ].icn : $root.icons.dir"></i>
          <i v-else :class="$root.prod_icons[item.typ] ? $root.prod_icons[item.typ].icn : $root.icons.dir" @click.stop="toggle()"><span v-if="configs.showValidity" class="icon-toggle-validity"> 
            <strong v-if="!showDetail">+</strong>
            <strong v-else style="font-size: small;">x</strong>
          </span></i>
        </span>
        <!-- children.length > 0 || !item.opened -->
        <span v-if="item.gco && !loading" @click.stop="arrow_clicked()" style="padding: 5px;"><i class="fa" :class="[children.length == 0 ? $root.icons.right : $root.icons.down]"></i></span>
        <div v-if="loading" class="custom_spinner" style="margin: 0px -3px 0px 3px;"></div>
        <div class="hide-collapse">
        <span v-if="configs.showId">{{item.sid + " - " }}</span>{{item.des}}</div>
      </div>
      </a>
       
    </div>

      <!-- carica tutto l'array dei figli nello stesso loop di rendering 
      <transition-group tag="ul" name="scroll" class="sidebar-menu" :class="{'first': isFirstSon, 'child': !isFirstSon}"
			:id="heir"> -->
      <ul class="sidebar-menu" :class="{'first': isFirstSon, 'child': !isFirstSon, 'fatherlast': isFirstSon || ind == $parent.children.length - 1 }"
			:id="heir">
          <li class="pageLink" v-for="(child, index) in children" v-if="item.opened" :key="child.sid">

            <recursive-item v-if="child.triggered" :item="child" :ind="index" :configs="configs" :executeOnOpen="child.execonopen" :navigationPendingPromise="child.nav_promise"
            @shrimp_build_path="ShrimpBuildPath">
            </recursive-item>

            <div v-else class="row row-wrap">
              <!-- rem ellipsis -->
              <a :id="child.sid" class="col-xs-12 aItem row sideless" style="margin: 0px;" @click.prevent="toggleOnSon('item_clicked', index)">

                <div class="icon-text-container">
                      <span style="padding: 0px;">
                        <!-- width: 5%; -->
                        <div class="sideless side-branch"
                        v-if="children != null"
                        :class="{'last': index == children.length - 1}">
                          <div class="branch top"></div>
                          <div class="branch bot"></div>
                        </div>
                        <i v-if="!configs.showValidity || true" :class="$root.prod_icons[child.typ] ? $root.prod_icons[child.typ].icn : $root.icons.dir"></i> 
                        <i v-else @click.stop="toggleOnSon('toggle', index)" :class="$root.prod_icons[child.typ] ? $root.prod_icons[child.typ].icn : $root.icons.dir"><span v-if="configs.showValidity" class="icon-toggle-validity"> 
                          <strong>+</strong>
                        </span></i>
                      </span>
                      <!-- children.length > 0 || !item.opened -->
                      <span v-if="child.gco" @click.stop="toggleOnSon('arrow_clicked', index)" style="padding: 5px;"><i :class="$root.icons.right"></i></span>
                      <div class="hide-collapse">
                      <span v-if="configs.showId">{{child.sid + " - " }}</span>{{child.des}}</div>
                  </div>
                </a>
            
              </div>
          </li>
          <li class="pageLink" v-for="(leaf, i) in leaves" :key="leaf.sid">

            <recursiveListDocument :item="leaf" :ind="i" :configs="configs" @shrimp_build_path="ShrimpBuildPath">
            </recursiveListDocument>

          </li>

        </ul>
      <!-- </transition-group> -->
      
	</span>
</template>

<script>
import { eventBus } from "../../eventbus";
import recursiveListDocument from "./recursive-list-document.vue";

export default {
  name: "recursive-item",
  props: {
    item: Object,
    ind: Number,
    configs: Object,
    executeOnOpen: String,
    navigationPendingPromise: Object
  },
  components:{
    recursiveListDocument
  },
  mounted: function() {
    if (this.$parent.$el.id == "" || !this.$parent.$el.id) {
      this.heir = 0;
    } else {
      this.heir = parseInt(this.$parent.$el.id) + 1;
    }
    this.am_i_leaf = false;
    if(this.executeOnOpen != null){
      var expandCmd = this.executeOnOpen.split("$");
      if(expandCmd.length > 1 && expandCmd[0] == "expand"){
        this.expand(JSON.parse(expandCmd[1]),Number(expandCmd[2]), expandCmd[3], this.navigationPendingPromise)
      } else {
        this[this.executeOnOpen]()
      }
    }
  },
  beforeDestroy: function () {
    this.children = null;
  },
  data: function() {
    var vm = this;
    return {
      children: [],
      leaves: [],
      stillDown: false,
      showDetail: false,
      heir: 0,

      am_i_leaf: false,
      light_expanded: false,
      loading: false
    };
  },
  computed: {
    isFirstSon: function() {
      return this.$parent.children == null;
    }
  },
  methods: {
    toggleOnSon: function(functionName, index){
      this.children[index].triggered = true;
      this.children[index].execonopen = functionName; 
      this.$forceUpdate();
    },
    item_clicked: function() {
      if(bowser.name.toLowerCase().includes('edge') && !this.$root.showNotific){
        this.$root.showNotific = true;
        this.$root.simpleNotification("info", {
            title: "", 
            message: this.$Jed.firstUpperTranslate("use mouse wheel to scroll the tree"),
            position: 'topLeft', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
            displayMode: 'once' // once, replace
        });
      }
      eventBus.$emit("closeSidebarDocumenti")
      this.expand();
    },
    expand: function(path, step, focus, nav_promise) {
      //path e step undefined, a meno che la chiamata non arrivi dal padre (navigazione diretta)

      this.closeDetail();
      //se sono un nodo foglia, e sono già espanso, non eseguo nulla
     
      if (this.item.cco != 0) {
        //eseguo richiesta se l'elemento è passato da compresso a espanso, oppure anche se era già parzialmente espanso da lightQuery, oppure se è un nodo foglia
       
        this.item.opened = (!this.item.opened || this.light_expanded || this.item.gco == null);
        if (this.item.opened) {
          //trigger timeout per mostrare spinner di caricamento
          this.trigger();
          this.queryThis(this.item.sid, this.item.fid, path, step, focus, nav_promise);
        } else {
          this.children = [];
          this.leaves = [];
        }
        //in ogni caso, in seguito il flag light expanded passa a false
        this.light_expanded = false;
      }
    },
    arrow_clicked: function(){
      //replico la procedura di expand, con le differenze seguenti:
      this.closeDetail();
      if(this.item.cco != 0){
        this.item.opened = !this.item.opened;
        if(this.item.opened){
          // 1ª il flag light_expanded passa a true prima di chiamare lightQueryThis
          this.light_expanded = true;
          this.trigger();
          // 2ª lightQueryThis non trasmette parametri path e step, dato che non viene usata da navigateTo per la navigazione diretta
          this.lightQueryThis(this.item.sid)
        } else {
          this.light_expanded = false;
          this.children = [];
        }
      }
    },
    trigger: function(){
      var vm = this;
      setTimeout(function(){
        if(vm.children && vm.children.length == 0 && !vm.am_i_leaf){
          vm.loading = true;
        }
      },1);
    },
    lightQueryThis: function(id){
      this.$root
        .microservice({
          role: "catalog",
          cmd: "SearchByFather",
          params: {
            fid: id,
            prod_info: ["typ"],
            labels: ["des"],
            leaves: false,
            meta: false
          }
        })
        .then(
          response => {
            var res = response.body;
            try {
              res = JSON.parse(response.body);
            } catch (err) {}

            this.children = [];
            if (res.children) {
              for (var i = 0; i < res.children.length; i++) {
                
                var obj = res.children[i];
                if(!obj.lin){
                  obj.opened = false;
                  obj.triggered = false;
                  obj.execonopen = null;
                  this.children.push(obj);
                }
              }
              if (this.$root.validity != null) {
                //this.children = this.$root.parseValidity(this.children)
              }
            }

            if (this.children.length == 0) {
              this.am_i_leaf = true;
            }
            this.loading = false;
          },
          err => {
            this.loading = false;
            console.log('recursive-list-item - lightQueryThis')
            console.log(err)
          }
        )
        .catch(err => {
            console.log(err);
            var msg = err.body.error ? err.body.error : ''
            eventBus.$emit('alert', {
                message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
                type: "error",
                action: ''
            })
        });
    },
    queryThis: function(id, fid, path, step, focus, nav_promise) {
      var vm = this;
      //Replico il controllo della changeRoute per determinare se serve un fetchAncestors
      var fetchAncestors = false

      if(this.$root.preferences.getAncestors){
        if (path != null && step != null) {
          var extract;
          try {
            extract = path[step + 1].id;
          } catch (err) {
            console.log(err)
          }
          if (extract == null || extract == "") {
            fetchAncestors = true;
          }
        } else {
          fetchAncestors = true;
        }
      }
      
      new Promise(function(resolve,reject){
        //propago un evento verso i genitori dell'elemento attivo, in modo da ricostruire a ritroso il percorso UNIVOCO dell'elemento
        //la promise verrà risolta solo in SidebarMenu, quando la propagazione avrà raggiunto il nodo radice
        if(fetchAncestors){
          vm.$emit("shrimp_build_path", {"path": [], "resolve": resolve, "reject": reject})
        } else {
          resolve(null)
        }

      }).then((makeshiftPath) => {
        // console.log(makeshiftPath);
        //makeshiftPath format [{id: "Root", des: "RADICE"}, {id: "1", des: "UNO"}, ...]
        //il formato è quello usato dal breadcrumb, ma il percorso da tracciare come query di vue-router deve essere mappato a stringa di id...
        //PATH Serial ID
        var argPath = "[]";
        if(makeshiftPath){
          var SID_PATH = makeshiftPath.map(function(step){
            return step.id;
          }).join("?")
          
          try {
            argPath = JSON.stringify(makeshiftPath)
          } catch (err) {
            console.log("caught error on stringify active path: ", err)
          }
        }

        this.$root
        .microservice({
          role: "catalog",
          cmd: "SearchByFather",
          params: {
            fid: id,
            // aggiunto gfid nelle searchByFather che richiedono info sul padre (meta: true), così posso identificare univocamente il nodo, e non cercare per "sid": fid ottenendo un primo res casuale
            gfid: fid,
            labels: "all",
            leaves: true,
            prod_info: ["att", "not", "gra", "typ", "spi", "doc", "mqt","iti","pib","ava","uni"],
            meta: true,
            meta_prod_info: ["gra", "typ", "def","iti","bvi","pvi"],
            saleability: true,
            pathString: fetchAncestors ? argPath : null,
            findAncestors: fetchAncestors
          }
        })
        .then(
          response => {
            var res = response.body;
            try {
              res = JSON.parse(response.body);
            } catch (err) {}

            this.children = [];
            if (res.children) {
              for (var i = 0; i < res.children.length; i++) {
                var obj = res.children[i];
                if(!obj.lin){
                    obj.opened = false;
                    obj.triggered = false;
                    obj.execonopen = null;
                    obj.nav_promise = null;

                    this.children.push(obj);
                }
              }
             
              if (path != null && step != null) {
                var extract;
                try {
                  extract = path[step + 1].id;
                } catch (err) {
                  console.log(err)
                }
                if (extract == null || extract == "") {
                  this.changeRoute(res, focus, {"path": path, "step": step, "nav_promise": nav_promise});
                  //quando sto eseguendo una navigazione diretta, commit active item solo all'ultimo step della procedura
                 
                } else {
                  this.$nextTick(function() {
                    this.direct(path, step, focus, nav_promise);
                  });
                  this.loading = false;
                }
                
              } else {
                this.changeRoute(res); 
              }
            } else {
              this.loading = false;
            }

            if (this.children.length == 0) {
              this.am_i_leaf = true;
            }

            this.leaves = []
            if(res.leaves){
              for (var i = 0; i < res.leaves.length; i++) {
                var obj = res.leaves[i];
                if(obj.typ == 'Articoli di stampa'){
                  this.leaves.push(obj);
                }
              }
            }
            
            try{
              if(res.answer.bvi){
                this.$root.blockedGridView = true;
                document.getElementById("switch_detail").style.cursor = 'not-allowed'
                document.getElementById("switch_table").style.cursor = 'not-allowed'
                document.getElementById("switch_img").style.cursor = 'not-allowed'
              }else{
                this.$root.blockedGridView = false
                document.getElementById("switch_detail").style.cursor = 'context-menu'
                document.getElementById("switch_table").style.cursor = 'context-menu'
                document.getElementById("switch_img").style.cursor = 'context-menu'
              }
            }catch(e){}
          },
          err => {
            this.loading = false;
            console.log('recursive-list-item - queryThis')
            console.log(err)
            //vedi gestione errore in main.js > microservice
          }
        )
        .catch(err => {
            console.log(err);
            var msg = err && err.body && err.body.error ? err.body.error : err
            eventBus.$emit('alert', {
              message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
              type: "error",
              action: ''
            })
        });
      });
      

      /*
      this.$root
        .microservice({
          role: "catalog",
          cmd: "SearchByFather",
          params: {
            fid: id,
            // aggiunto gfid nelle searchByFather che richiedono info sul padre (meta: true), così posso identificare univocamente il nodo, e non cercare per "sid": fid ottenendo un primo res casuale
            gfid: fid,
            labels: "all",
            leaves: true,
            prod_info: ["att", "not", "gra", "typ", "spi", "doc", "mqt","iti"],
            meta: true,
            meta_prod_info: ["gra", "typ", "def","iti"],
            saleability: true
          }
        })
        .then(
          response => {
            var res = response.body;
            try {
              res = JSON.parse(response.body);
            } catch (err) {}

            this.children = [];
            if (res.children) {
              for (var i = 0; i < res.children.length; i++) {
                var obj = res.children[i];
                if(!obj.lin){
                    obj.opened = false;
                    obj.triggered = false;
                    obj.execonopen = null;
                    obj.nav_promise = null;

                    this.children.push(obj);
                }
              }
             
              if (path != null && step != null) {
                var extract;
                try {
                  extract = path[step + 1].id;
                } catch (err) {
                  console.log(err)
                }
                if (extract == null || extract == "") {
                  this.changeRoute(res, focus, {"path": path, "step": step, "nav_promise": nav_promise});
                  //quando sto eseguendo una navigazione diretta, commit active item solo all'ultimo step della procedura
                 
                } else {
                  this.$nextTick(function() {
                    this.direct(path, step, focus, nav_promise);
                  });
                  this.loading = false;
                }
                
              } else {
                this.changeRoute(res); 
              }
            } else {
              this.loading = false;
            }

            if (this.children.length == 0) {
              this.am_i_leaf = true;
            }

            this.leaves = []
            if(res.leaves){
              for (var i = 0; i < res.leaves.length; i++) {
                var obj = res.leaves[i];
                if(obj.typ == 'Articoli di stampa'){
                  this.leaves.push(obj);
                }
              }
            }
          },
          err => {
            this.loading = false;
            console.log('recursive-list-item - queryThis')
            console.log(err)
            //vedi gestione errore in main.js > microservice
          }
        )
        .catch(err => {
            console.log(err);
            var msg = err.body.error ? err.body.error : ''
            eventBus.$emit('alert', {
              message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
              type: "error",
              action: ''
            })
        });
      */
      
    },
    changeRoute: function(res, focus, nextParams) {
      var vm = this;
      new Promise(function(resolve,reject){
        //propago un evento verso i genitori dell'elemento attivo, in modo da ricostruire a ritroso il percorso UNIVOCO dell'elemento
        //la promise verrà risolta solo in SidebarMenu, quando la propagazione avrà raggiunto il nodo radice
        vm.$emit("shrimp_build_path", {"path": [], "resolve": resolve, "reject": reject})
      }).then((makeshiftPath) => {
        // console.log("RESOLVED MAKESHIFT PATH")
        // console.log(makeshiftPath);
        /* ------------- prints info */
        //makeshiftPath format [{id: "Root", des: "RADICE"}, {id: "1", des: "UNO"}, ...]
        //il formato è quello usato dal breadcrumb, ma il percorso da tracciare come query di vue-router deve essere mappato a stringa di id...
        //PATH Serial ID
        var SID_PATH = makeshiftPath.map(function(step){
          return step.id;
        }).join("?")
        // inizializzo idp (per ora ha il solo scopo di identificare l'elemento attivo)
        vm.item["idp"] = SID_PATH;

        //AGGIORNA E NOTIFICA NODEWRAPPER E FIGLI
        //emetto evento "è stato cliccato un nodo"
        //l'evento setta in NodeWrapper "ignoreIdle" a true, per fargli intendere che il cambiamento di route.params è causato da una navigazione già avvenuta (non da back del browser)
        eventBus.$emit("node_clicked");
        //metto l'id del nodo cliccato come parametro dell'url a cui navigare
        if(focus != null && focus != "undefined"){
          this.$router.push({
            name: "wrapper_focus",
            params: {
              id:  this.$root.encode(this.item.sid),
              focus: focus
            },
            query: {
              p: SID_PATH
            }
          })
        } else {
          this.$router.push({
            name: "wrapper",
            params: {
              id:  this.$root.encode(this.item.sid)
            },
            query: {
              p: SID_PATH
            }
          });
        }
        //aggiorno lo store condiviso con il riferimento all'elemento attivo
        this.$store.commit("setActive", {
          father: res.answer,
          children: res.children,
          leaves: res.leaves
        });
        //segnalo alla view e sub-view di dettaglio di refreshare i contenuti
        eventBus.$emit("detail_changed");

        //AGGIONRA E NOTIFICA BREADCRUMB
        if (res.answer) {
          var answer = res.answer;
          var active_item = { 
            id: answer.sid, 
            des: answer.des, 
            typ: answer.typ,
            spe: answer.spe, 
            pos: answer.pos,
            fid: answer.fid,
            qty: answer.qty,
            spi: answer.spi,
            not: answer.not
          };
          if (this.$root.active_tree_item != active_item) {
            this.$root.active_tree_item = active_item;
            this.$root.active_tree_path = makeshiftPath;
            eventBus.$emit("active_changed");
          }
        }

        if(nextParams){
          // nextParams è valorizzato solo se è in corso una navigazione diretta, anche questa logica la implemento a fine promise
          this.$nextTick(function() {
            this.direct(nextParams.path, nextParams.step, focus, nextParams.nav_promise);
          });
        }
        this.loading = false;
      }, (err) => {
        console.log("MAKE PATH PROMISE REJECTED")
        console.log(err)
      })
      //END THEN
    },
    ShrimpBuildPath: function(e){
      e.path.unshift({'id': this.item.sid, 'des': this.item.des})
      //propago l'evento per costruire il path a ritroso, fino alla radice in SidebarMenu
      this.$emit("shrimp_build_path", {"path": e.path, "resolve": e.resolve, "reject": e.reject})
    },
    activeChanged: function(id, answer) {
      var active_item = { 
        id: id, 
        des: answer.des, 
        path: answer.idp,
        typ: answer.typ,
        spe: answer.spe, 
        pos: answer.pos,
        fid: answer.fid,
        qty: answer.qty,
        spi: answer.spi,
        not: answer.not
      };
      if (this.$root.active_tree_item != active_item) {
        this.$root.active_tree_item = active_item;
        this.$root.active_tree_path = answer.path;
        eventBus.$emit("active_changed");
      }
    },
    direct: function(path, step, focus, nav_promise) {
      step++;
      var extract;
      try {
        extract = path[step].id;
      } catch (err) {}
      //controllo inverso (prima di chiamare questa func controllo che extract sia nullo, e nel caso navigo alla vista dettaglio)
      //qui controllo che esista e continuo la ricerca nell'albero
      if (extract != null && extract != "") {
        var found = false;
        //cerco fra quelli triggered almeno una volta (nei casi pessimi sono molti di meno di quelli mai aperti)
        for (var i = 0; i < this.$children.length; i++) {
          if (this.$children[i].item != null) {
            if (this.$children[i].item.sid == extract) {
              this.$children[i].expand(path, step, focus, nav_promise);
              found = true;
              break;
            }
          }
        }
        if(!found){
          //altrimenti cerco fra i figli non ancora triggherati
          for (var i = 0; i < this.children.length; i++) {
            if (this.children[i].sid == extract) {
              found = true;
              this.children[i].triggered = true; 
              this.children[i].execonopen = "expand$"+JSON.stringify(path)+"$"+step+"$"+focus;
              this.children[i].nav_promise = nav_promise;
              this.$forceUpdate();
              break;
            }
          }
        }
        if(!found){
          nav_promise.reject();
        }
      } else {
        eventBus.$emit("end_nav", this.item.sid, nav_promise);
      }
    },
    // -- METODI PER VISUALIZZAZIONE DETTAGLIO --
    toggle: function() {
      this.showDetail = !this.showDetail;
    },
    closeDetail: function() {
      this.showDetail = false;
    },
    getStartValidity: function(item) {
      if (this.$Behaviors.updatesReference == "date") {
        return this.getDate(item.div);
      } else {
        return item.miv;
      }
    },
    getEndValidity: function(item) {
      if (this.$Behaviors.updatesReference == "date") {
        return this.getDate(item.dfv);
      } else {
        return item.mfv;
      }
    },
    getDate: function(d) {
      try {
        var obj = new Date(d);
        return obj.toLocaleDateString();
      } catch (err) {
        console.log("Err parsing ISO Date");
        console.log(err);
        return d;
      }
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tree/recursive-list-item.vue?4f111966